import React, { useState } from 'react';
import PropTypes from 'prop-types';
import JobsSectionPresentation from './JobsSectionPresentation';
import useGetJobList from '../../../common/apiCalls/jobs';
import useGetCities from '../../../common/apiCalls/cities';
import useGetTeams from '../../../common/apiCalls/teams';

export default function JobsSectionContainer({ isMobile, recaptchaRef }) {
  const [teams, setTeams] = useState([]);
  const [citiesCount, setCitiesCount] = useState();
  const [jobsCount, setJobsCount] = useState();

  useGetJobList({ onSuccess: (jobsList) => setJobsCount(jobsList.length) });
  useGetTeams({ onSuccess: (data) => setTeams(data) });
  useGetCities({ onSuccess: (data) => setCitiesCount(data?.length) });

  return (
    <JobsSectionPresentation
      isMobile={isMobile}
      teams={teams}
      jobsCount={jobsCount}
      citiesCount={citiesCount}
      recaptchaRef={recaptchaRef}
    />
  );
}

JobsSectionContainer.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  recaptchaRef: PropTypes.object.isRequired,
};
